import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoanNumberTableComponent } from './components/loan-number-table/loan-number-table.component';
import { LTGenericGridPngComponent } from './components/lt-generic-grid-png/lt-generic-grid-png';
import { LTGenericGridWrapperComponent } from './components/lt-generic-grid-wrapper/lt-generic-grid-wrapper';
@NgModule({
  imports: [
    CommonModule,
    LoanNumberTableComponent,
    LTGenericGridPngComponent,
    LTGenericGridWrapperComponent,
  ],
  exports: [
    LoanNumberTableComponent,
    LTGenericGridPngComponent,
    LTGenericGridWrapperComponent,
  ],
})
export class LTGridUIModule { }